export const wireConfirmationWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
